import React, { useEffect, useState } from 'react';
import BASE_API_URL from "../../apis/index";
import styled from "styled-components";
import { Box, Card, CardContent, Chip } from '@mui/material';
import { Carousel } from 'react-bootstrap';
import axios from 'axios';

export default function CompProductsSectionIngDist({ compId, compName, compTypes, userId }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function fetchProducts() {
      try {
        const authToken = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_API_URL}/api/buyer/company/products/${compId}`, {
          params: { company_type: "Ingredient Distributor" },
          headers: { Authorization: `Bearer ${authToken}` },
        });
        setProducts(res.data || []);
      } catch (err) {
        console.error("Failed to fetch products", err);
      }
    }
    fetchProducts();
  }, [compId]);

  if (!products.length) { return(<></>) }

  return (
    <CompProductsSectionWrapper className="py-md-5 p-5 rounded-5 bg-light my-5">
      <h5 className="fw-noraml txt_color_primary mb-3"> Products - Ingredient Distributor ({products.length}) </h5>
      {/* <Divider textAlign="left" className="mb-4"> Products found: {products.length} </Divider> */}
      <div className="d-flex flex-wrap gap-3" spacing={3}>
        {products.length > 0 && products.map((product) => {
          const images = product.product_images ? JSON.parse(product.product_images) : [];
          return (
            <div className="ProductCard" key={product.id}>
              <Card className='shadow-none border shadow-none rounded-3 overflow-hidden'>
                {/* Product Image Carousel */}
                {images.length > 0 ? (
                  <Carousel indicators={false} wrap={false}>
                    {images.map((img, idx) => (
                      <Carousel.Item key={idx}>
                        <img
                          className="d-block w-100"
                          src={`${BASE_API_URL}/uploads/user_prod_docs/${img}`}
                          alt={`product-${product.id}-${idx}`}
                          style={{
                            height: "200px",
                            objectFit: "cover",
                          }}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : (
                  <Box
                    sx={{
                      height: 200,
                      background: "#f0f0f0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div color="text_secondary"> No Image </div>
                  </Box>
                )}

                {/* Product Details */}
                <CardContent>
                  <div className='fw-medium text-dark mb-3'> {product.product_name} </div>
                  <Chip className="me-2 mb-2 rounded-1" label={<span className="text-white"> {product.category} </span>} size="small" color="secondary" />

                  <div color="text_secondary"> Type: {product.product_type} </div>
                  <div color="text_secondary" className="mb-4"> Price: {product.pricing} {product.currency} </div>
                 
                  <a className="CardLink" href={`/product-details?prodId=${product.id}&compId=${compId}&compName=${compName}`}> View Details </a>
                </CardContent>
              </Card>
            </div>
          );
        })}
      </div>
    </CompProductsSectionWrapper>
  );
}

const CompProductsSectionWrapper = styled.div`
  .ProductCard{
      width: 380px;
      height: 420px;
  }
  .CardLink{
      border: 1px solid var(--secondary-color);
      padding: 10px 25px; 
      color: var(--secondary-color);
      font-size: 0.8rem;
      text-decoration: none;
      cursor: pointer;
      border-radius: 5px;
      transition: 0.5s;
      &:hover{
        background: var(--secondary-color);
        color: white;
      }
  }
`;